import { render, staticRenderFns } from "./VentaMismaButaca.vue?vue&type=template&id=d26d2146"
import script from "./VentaMismaButaca.vue?vue&type=script&lang=js"
export * from "./VentaMismaButaca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports